import { combineReducers, configureStore } from "@reduxjs/toolkit";
import sessionSlice from "./slices/sessionSlice";
import universitySlice from "./slices/universitySlice";
import userActivitySlice from "./slices/userActivitySlice";
import authSlice from './slices/authSlice'
import cartSlice from './slices/cartSlice'
import sportSlice from './slices/sportSlice'
import userSlice from './slices/userSlice'
import seasonSlice from './slices/seasonSlice'
import snackbarSlice from './slices/snackbarSlice'
import googleAuthSlice from './slices/googleSlice'
import paymentSlice from './slices/paymentSlice'
import deployTokenSlice from './slices/deployTokenSlice'
import rewardSlice from './slices/rewardSlice'
import earnPointSlice from './slices/earnPointSlice'
import liveGameSlice from './slices/liveGameSlice'
import publicSlice from './slices/publicSlice'
import purchaseHistorySlice from './slices/purchaseHistorySlice'
import updateUserSlice from './slices/updateUserSlice'
import scorerSlice from './slices/scorerSlice'
import passwordPolicySlice from './slices/passwordPolicySlice'

const reducers = combineReducers({
    session: sessionSlice, // Register the session slice reducer
    university: universitySlice, // Register the university slice reducer
    userActivity: userActivitySlice, // Register the userActivity slice reducer
    googleAuth: googleAuthSlice, // google-authentication reducer
    auth: authSlice, // Register the auth slice reducer
    user: userSlice, // Register the user slice reducer
    snackbar: snackbarSlice, // Snackbar/ Toast slice reducer
    cart: cartSlice, // Cart slice reducer
    sport: sportSlice, // Sport slice reducer
    payment: paymentSlice, //Payment slice reducer
    seasons: seasonSlice, // Season slice reducer
    deployToken: deployTokenSlice,  // DeployToken slice reducer
    reward: rewardSlice, // Reward slice reducer
    earnPoint: earnPointSlice, //Earn Point slice reducer
    liveGame: liveGameSlice, //live game slice reducer
    public: publicSlice, // Public slice reducer
    purchaseHistory: purchaseHistorySlice, // Purchase History slice reducer
    updateUser: updateUserSlice, // Update User slice reducer
    scorer: scorerSlice, // Scorer slice reducer
    passwordPolicy: passwordPolicySlice
});

const rootReducer = (state, action) => {
    if (action.type === 'user/logMeOut') { // check for action type 
      state = undefined;
    }
    return reducers(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV === "development", // Enable Redux DevTools in development only
});

export default store;
